import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

export function ScrollToTop() {
  const location = useLocation()

  // Scroll to top on every real route change.
  useEffect(() => {
    scrollToTop()
  }, [location.pathname, location.search])

  // Also scroll to top when the user clicks any internal link, even if it
  // points to the page they are already on (React Router may skip the update).
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      const anchor = target.closest('a')
      if (!anchor) return

      const href = anchor.getAttribute('href')
      if (!href) return

      // Skip anchors, external links, and special protocols.
      if (
        href.startsWith('#') ||
        href.startsWith('http') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:')
      ) {
        return
      }

      scrollToTop()
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  return null
}
